import React from "react";

import { IconTickets, IconPerson, IconSignOut, IconCog } from "@busbud/horizon";

import type { TranslatorService } from "@app/services/translator";
import type UrlBuilderService from "@app/services/url-builders/url-builder";

import type { Page } from "../account-navigation";
import type { NavigationItem } from "../account-navigation-item";

interface NavigationItemData extends NavigationItem {
  isSelected: (current_page: Page) => boolean;
}

export const getMenuItems = (
  translator: TranslatorService,
  urlBuilder: UrlBuilderService,
  is_authenticated: boolean
): NavigationItemData[] => {
  const items: NavigationItemData[] = [];

  items.push(
    {
      label: translator.t("!account.navigation.trips"),
      url: urlBuilder.accountTrips(),
      Icon: () => <IconTickets size="md" />,
      isSelected: (current_page: Page) =>
        ["trips", "trip_details"].includes(current_page),
      account_section: "my_trips"
    },
    {
      label: translator.t("!landing.input-label.passengers"),
      url: urlBuilder.accountPassengerProfiles(),
      Icon: () => <IconPerson size="md" variant="multiple" />,
      isSelected: (current_page: Page) => current_page === "passengers",
      account_section: "passengers"
    },
    {
      label: translator.t("!account.navigation.settings"),
      url: urlBuilder.accountSettings(),
      Icon: () => <IconCog variant="solid" size="md" />,
      isSelected: (current_page: Page) => current_page === "settings",
      account_section: "settings"
    }
  );

  if (is_authenticated) {
    items.push({
      label: translator.t("!accounts.menu.logout"),
      url: urlBuilder.accountLogout(),
      Icon: () => <IconSignOut size="md" />,
      isSelected: () => false,
      account_section: "logout"
    });
  }

  return items;
};
